import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      // {
      //   'component': 'search-select-field', label: '사업장명', value: 'field', query: {'f_id': 'fieldId', 'f_name': 'fieldName'},
      //   options: {
      //     default: {fieldId: '', fieldName: ''},
      //     gridTemplateColumns: '114px 178px',
      //   }
      // },
      {
        component: "search-column-keyword",
        label: "검색",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["현장명", "상태"],
          boardId: 984,
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    if (search.field) {
      conditions.push({key: 'field_id', value: search.field.fieldId})
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });

    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], value: `${search.column.keyword}` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "현장명",
        key: "field_name",
      },
      {
        name: "아이디",
        key: "username",
      },
      {
        name: "이름",
        key: "name",
      },
      {
        name: "휴대폰번호",
        key: "phone",
      },
      {
        name: "이메일",
        key: "email",
      },
      {
        name: "업체명",
        key: "company",
      },
    ];
  },
  getCol: (index, value, func) => {},
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
